import { Breakpoints } from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';

export interface MobileTrimSelectionHeaderProps {
  readonly previousButton?: React.ReactNode;
  readonly counter: React.ReactNode;
  readonly nextButton?: React.ReactNode;
}

const StyledMobileTrimSelectionHeader = styled.div`
  margin: 0 ${(props) => props.theme.size.grid002};
  margin-bottom: ${(props) => props.theme.size.static350};
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;

  > :last-child {
    text-align: right;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    display: none;
  }
`;

export function MobileHeader({ previousButton, counter, nextButton }: MobileTrimSelectionHeaderProps): JSX.Element {
  return (
    <StyledMobileTrimSelectionHeader>
      <div>{previousButton}</div>
      <div>{counter}</div>
      <div>{nextButton}</div>
    </StyledMobileTrimSelectionHeader>
  );
}
